import React from 'react'
import PropTypes from 'prop-types'
import { Form, Input } from 'antd'
import css from './custom-mention-values.css'

const CustomMentionValues = ({
  locationId,
  customMentionValues,
  saveCustomMentionValue,
}) => {
  const list = customMentionValues || []
  if (!list.length) {
    return null
  }

  const onValueChange = (id, newValue) => {
    saveCustomMentionValue(locationId, { id, newValue })
  }

  return (
    <div className={css.wrapper}>
      <h4>Custom Mentions:</h4>
      <div className={css.itemInfo}>
        {list.map(item => (
          <div key={item.id}>
            <span className={css.labelSmall}>{item.label}</span>
            <Form.Item className={css.formItem}>
              <Input
                className={css.input}
                value={item.value == null ? '' : item.value}
                onChange={e => onValueChange(item.id, e.target.value)}
                />
            </Form.Item>
          </div>
        ))}
      </div>
    </div>
  )
}

CustomMentionValues.propTypes = {
  locationId: PropTypes.string.isRequired,
  customMentionValues: PropTypes.arrayOf(PropTypes.object),
  saveCustomMentionValue: PropTypes.func.isRequired,
}

CustomMentionValues.defaultProps = {
  customMentionValues: [],
}

export default CustomMentionValues



// WEBPACK FOOTER //
// ./src/AddPractice/Associations/CustomMentionValues.js